// extracted by mini-css-extract-plugin
export default {"detail":"LotDetails_detail__Hzr6-","lotActions":"LotDetails_lotActions__7IQJr","disapproveButton":"LotDetails_disapproveButton__JIri1"};